module.exports = __webpack_public_path__ + "img/logo.f3d8a341.png";